import React from 'react';
import { CreatePage } from '@components/common';
import RefillForm from '@components/common/forms/RefillForm';

const RefillCreatePage = () => {
    return (
        <CreatePage
            modelName="refills"
            FormComponent={RefillForm}
        />
    );
};

export default RefillCreatePage;
